import { useState, useEffect, useRef, useCallback } from 'react'
import Faye from 'faye'

const client = new Faye.Client('https://faye.voicearchive.com/faye', {
  timeout: 120,
  retry: 5,
})

export default function useNotifications(userId) {
  const [notifications, setNotifications] = useState([])
  const subscription = useRef(null)

  const onMarkSeen = useCallback((notificationId) => () => {
    setNotifications((notifications) => (
      notifications.filter(({ id }) => id != notificationId)
    ))

    fetch(`/rest/v2/notification/${notificationId}`, {
      credentials: 'same-origin',
      method: 'PUT'
    })
  }, [notifications])

  useEffect(() => {
    fetch(`/rest/v2/notification`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => setNotifications(data.map((notification) => ({
        ...notification,
        markSeen: onMarkSeen(notification.id)
      }))))

    const channel = `/voicearchive/user/${userId}/notifications`

    subscription.current = client.subscribe(channel, ({ body, title, url, id }) => {
      console.log('New message: ', {
        body,
        title,
        url,
        id,
      })

      setNotifications((notifications) => [
        ...notifications,
        {
          id: parseInt(id, 10),
          url,
          title,
          body,
          markSeen: onMarkSeen(id),
          created_at: +Date.now(),
        }
      ])
    })

    subscription.current.then(function() {
      console.log(`Subscribed to ${channel}`)
    })

    return () => {
      subscription.current.cancel()
    }
  }, [])

  return notifications
}
